function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useContext, useMemo, useRef, useState } from "react";
import cx from "classnames";
import split from "just-split";
import Flicking from "@egjs/react-flicking";
import { useUIDSeed } from "react-uid";
import { CarouselArrows, Section, SectionHeader } from "../../molecules";
import { ImageContext } from "../../../context";
export var CompanyLogos = function(param) {
    var label = param.label, title = param.title, logos = param.logos, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    var ref = _slicedToArray(useState(0), 2), activeIndex = ref[0], setActiveIndex = ref[1];
    var flickingRef = useRef(null);
    var chunked = useMemo(function() {
        return split(logos, 3);
    }, [
        logos
    ]);
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var handleChangeOrRestore = useCallback(function(event) {
        setActiveIndex(event.index);
    }, []);
    var handlePrev = useCallback(function() {
        var ref;
        (ref = flickingRef.current) === null || ref === void 0 ? void 0 : ref.prev();
    }, []);
    var handleNext = useCallback(function() {
        var ref;
        (ref = flickingRef.current) === null || ref === void 0 ? void 0 : ref.next();
    }, []);
    var _sizes, _alt;
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        backgroundColor: "offdefault",
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-7 md:gap-10"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        label: label,
        title: title,
        labelColor: "secondary",
        sideContent: /*#__PURE__*/ React.createElement(CarouselArrows, {
            className: "hidden justify-end mt-auto md:flex",
            canGoBack: activeIndex > 0,
            canGoForward: activeIndex < chunked.length - 1,
            onPrev: handlePrev,
            onNext: handleNext
        })
    }), /*#__PURE__*/ React.createElement("div", {
        className: "-mx-5 grayscale"
    }, /*#__PURE__*/ React.createElement(Flicking, {
        ref: flickingRef,
        moveType: "strict",
        firstPanelSize: "100%",
        onWillChange: handleChangeOrRestore,
        onWillRestore: handleChangeOrRestore
    }, chunked.map(function(chunk) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(chunk),
            className: cx("flicking-panel w-full px-5 pointer-events-none grid grid-cols-2 items-center justify-center gap-8", "md:grid md:grid-cols-3")
        }, chunk.map(function(param) {
            var logo = param.logo, logoLabel = param.label;
            return /*#__PURE__*/ React.createElement("div", {
                key: seed(logo),
                className: "flex justify-center"
            }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, logo, {
                sizes: (_sizes = logo.sizes) !== null && _sizes !== void 0 ? _sizes : "(min-width: 48em) 35vw, 50vw",
                className: "w-[11.5rem] h-[8rem] object-contain object-center",
                alt: (_alt = logo.alt) !== null && _alt !== void 0 ? _alt : logoLabel
            })));
        }));
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(CarouselArrows, {
        className: "flex md:hidden",
        canGoBack: activeIndex > 0,
        canGoForward: activeIndex < chunked.length - 1,
        onPrev: handlePrev,
        onNext: handleNext
    }))));
};

//# sourceMappingURL=CompanyLogos.js.map